import { NuggetSearchBusinessParams, NuggetSearchBusinessResponse } from "types";

import API from "api/client";
import { envConfig } from "config";

const { nuggetsAPI } = envConfig;

/**
 * Search for a nugget preset traits via the provided params.
 */
const searchNuggetPresetTraitBusiness = ({
  query = "",
  page = 1,
  size = 10,
}: NuggetSearchBusinessParams): Promise<NuggetSearchBusinessResponse> => {
  return API.get(`${nuggetsAPI}preset-trait-business`, { params: { query, page, size } }).then((res) => res.data);
};

export default {
  searchBusiness: searchNuggetPresetTraitBusiness,
};
